import { render, staticRenderFns } from "./ViewStatus.vue?vue&type=template&id=52d55202&scoped=true&lang=pug"
import script from "./ViewStatus.vue?vue&type=script&lang=js"
export * from "./ViewStatus.vue?vue&type=script&lang=js"
import style0 from "./ViewStatus.vue?vue&type=style&index=0&id=52d55202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d55202",
  null
  
)

export default component.exports